"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationDateInput = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../common");
const moment_1 = __importDefault(require("moment"));
exports.DurationDateInput = (0, react_1.forwardRef)(({ title, firstDisabled = false, secondDisabled = false, defaultFirstValue = '', defaultSecondValue = '', handlerFirstUpdate, handlerSecondUpdate, noShowButtonArea = false, buttonStyle = {
    width: '123px',
}, buttonOption, status, ...props }, ref) => {
    const firstInputRef = (0, react_1.useRef)(null);
    const secondInputRef = (0, react_1.useRef)(null);
    const [firstValue, setFirstValue] = (0, react_1.useState)(defaultFirstValue);
    const [secondValue, setSecondValue] = (0, react_1.useState)(defaultSecondValue);
    (0, react_1.useImperativeHandle)(ref, () => ({
        focusFirst: () => firstInputRef.current?.focus(),
        focusSecond: () => secondInputRef.current?.focus(),
        getFirstValue: () => firstValue,
        getSecondValue: () => secondValue,
        setFirstValue: (newValue) => {
            setFirstValue(newValue);
            if (firstInputRef.current) {
                firstInputRef.current.value = newValue;
            }
        },
        setSecondValue: (newValue) => {
            setSecondValue(newValue);
            if (secondInputRef.current) {
                secondInputRef.current.value = newValue;
            }
        },
    }));
    const onFirstChange = (e) => {
        const newValue = e.target.value;
        const newDate = (0, moment_1.default)(newValue);
        const secondDate = (0, moment_1.default)(secondValue);
        if (secondValue && newDate.isAfter(secondDate)) {
            alert('시작일은 종료일보다 늦을 수 없습니다.');
            return;
        }
        setFirstValue(newValue);
        handlerFirstUpdate?.(newValue);
    };
    const onSecondChange = (e) => {
        const newValue = e.target.value;
        const newDate = (0, moment_1.default)(newValue);
        const firstDate = (0, moment_1.default)(firstValue);
        if (firstValue && newDate.isBefore(firstDate)) {
            alert('종료일은 시작일보다 빠를 수 없습니다.');
            return;
        }
        setSecondValue(newValue);
        handlerSecondUpdate?.(newValue);
    };
    (0, react_1.useEffect)(() => {
        setFirstValue(defaultFirstValue);
        setSecondValue(defaultSecondValue);
        handlerFirstUpdate?.(defaultFirstValue);
        handlerSecondUpdate?.(defaultSecondValue);
    }, [defaultFirstValue, defaultSecondValue]);
    const today = (0, moment_1.default)().format('YYYY-MM-DD');
    const tommorow = (0, moment_1.default)().add(1, 'days').format('YYYY-MM-DD');
    return (react_1.default.createElement("div", { className: "text-input" },
        react_1.default.createElement("label", { className: "title" }, title),
        react_1.default.createElement("div", { className: "date_wrap" },
            react_1.default.createElement("input", { ref: firstInputRef, value: firstValue, onChange: onFirstChange, min: today, max: secondValue || undefined, disabled: firstDisabled, ...props }),
            react_1.default.createElement("span", null, "~"),
            react_1.default.createElement("input", { ref: secondInputRef, value: secondValue, onChange: onSecondChange, min: firstValue && firstValue > today ? firstValue : status === "active" ? tommorow : today, disabled: secondDisabled, ...props })),
        !noShowButtonArea && (react_1.default.createElement("div", { style: buttonStyle }, buttonOption && (react_1.default.createElement(common_1.Button, { className: buttonOption.className, text: buttonOption.title, onClick: buttonOption.handlerClick }))))));
});
